import { TipoDocumento } from "./tipo-documento.model";

export class RazonSocial {
    numero: string;
    id: number;
    tipo: TipoDocumento;
    fechaExpedicion: Date;
    fechaVencimiento: Date;
    /**
     * Constructor
     *
     * @param riesgo
     */
    constructor(riesgo) {
        {
            this.id = riesgo.id || null;
            this.numero = riesgo.numero || "";
            this.tipo = riesgo.tipo;
            this.fechaExpedicion = new Date(riesgo.fechaExpedicion);
            this.fechaVencimiento = new Date(riesgo.fechaVencimiento);
        }
    }
}
